import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Offcanvas, Button } from "react-bootstrap";
import { FiMenu } from "react-icons/fi";
import ColourFilterBox from "../../../../components/FilterBox/ColourFilter/ColourFilter";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import ColourTable from "../../../../components/Tables/ColourTable";
import ColourParentChild from "../../../../components/Tables/ColourParentChild";
import {
  ColourFilter,
  ProdGrpMachineWiseCon,
  ProdGrpMachineWiseConFun,
} from "../../../../Redux/Slice/Colour/InwardAnylysis/InwardAnylysis";
import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext";

export const MasterWiseConsumption = () => {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { ProdGrpMachineWiseCondata, ColourfilterData } = useSelector(
    (state) => state.InwardAnylysisSlice,
  );
  const { theme } = useTheme();
  const isdark = theme;

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICL",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICLDARK",
  );

  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");

  const [showFilter, setShowFilter] = useState(false);
  const [activeTable, setActiveTable] = useState("Machine Wise");
  const [dynamic, setdynamic] = useState("IssueMonthName");

  const DEFAULT_MONTH = "04";

  

  const selectedYearObj = DataMain?.AC_Year_List?.find(
    (y) => String(y.AcYearID) === String(FinancialYear),
  );

  const parseAcYear = (acYearStr) => {
    if (!acYearStr) return null;

    const [start, end] = acYearStr.split(" - ");

    const formatDate = (d) => {
      const [dd, mm, yyyy] = d.split("/");
      return `${yyyy}-${mm}-${dd}`;
    };

    return {
      start: formatDate(start),
      end: formatDate(end),
    };
  };

  const financialYearRange = parseAcYear(selectedYearObj?.AcYear);

  const FinYearStart = financialYearRange?.start;
  const FinYearEnd = financialYearRange?.end;

  const getMonthId = (monthValue) => {
    if (!FinYearStart || !FinYearEnd) return "";

    const startYear = new Date(FinYearStart).getFullYear();
    const endYear = new Date(FinYearEnd).getFullYear();

    // Jan–Mar → next year
    const year = Number(monthValue) <= 3 ? endYear : startYear;
    console.log(year);

    return `${year}${monthValue}`; // ex: 202404
  };

  const monthList = [
    { name: "April", value: "04" },
    { name: "May", value: "05" },
    { name: "June", value: "06" },
    { name: "July", value: "07" },
    { name: "August", value: "08" },
    { name: "September", value: "09" },
    { name: "October", value: "10" },
    { name: "November", value: "11" },
    { name: "December", value: "12" },
    { name: "January", value: "01" },
    { name: "February", value: "02" },
    { name: "March", value: "03" },
  ];

  const [filters, setFilters] = useState({
    month: "",
    productionGroup: [],
  });

  const [search, setSearch] = useState({
    month: "",
    productionGroup: "",
  });

  const MonthListdata = monthList?.map((item) => ({
    label: item?.name,
    value: item?.value,
  }));

  const productionGroupList = ColourfilterData?.ProductionGroup?.map(
    (item) => ({
      label: item?.ProductionGroupMstName,
      value: item?.ProductionGroupMstID,
    }),
  );

  // const toggleItem = (type, item) => {
  //   setFilters((prev) => {
  //     let updatedSelected;

  //     if (type === "month") {
  //       // 👉 single select logic
  //       updatedSelected = prev.month === item.value ? "" : item.value;
  //     } else {
  //       const selected = prev[type];
  //       updatedSelected = selected.includes(item.value)
  //         ? selected.filter((i) => i !== item.value)
  //         : [...selected, item.value];
  //     }

  //     const newFilters = {
  //       ...prev,
  //       [type]: updatedSelected,
  //     };

  //     if (type === "productionGroup") {
  //       const finalMonth = newFilters.month || DEFAULT_MONTH;
  //       const monthIds = getMonthId(finalMonth);

  //       const payload = {
  //         FirmIDs: Firm,
  //         AcYearIDs: FinancialYear,
  //         ProductionGroupMstIDs: newFilters.productionGroup.join(","),
  //         monthIds: monthIds,
  //       };
  //       dispatch(ProdGrpMachineWiseConFun());
  //       dispatch(ProdGrpMachineWiseCon(payload));
  //     }

  //     return newFilters;
  //   });
  // };

  const toggleItem = (type, item) => {
    setFilters((prev) => {
      let updatedSelected;

      if (type === "month") {
        updatedSelected = prev.month === item.value ? "" : item.value;
      } else {
        const selected = prev[type];
        updatedSelected = selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value];
      }

      return {
        ...prev,
        [type]: updatedSelected,
      };
    });
  };
  const handleSearch = (type, val) => {
    setSearch((prev) => ({ ...prev, [type]: val }));
  };

  const selectAll = (type, list) => {
    const allIds = list.map((i) => i.value);
    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === list.length ? [] : allIds,
    }));
  };

  useEffect(() => {
    const finalMonth = filters.month || DEFAULT_MONTH;
    const monthIds = getMonthId(finalMonth);

    const payload = {
      FirmIDs: Firm,
      AcYearIDs: FinancialYear,
      ProductionGroupMstIDs: filters.productionGroup.join(","),
      monthIds: monthIds,
    };

    dispatch(ProdGrpMachineWiseConFun());
    dispatch(ProdGrpMachineWiseCon(payload));
  }, [filters.month, filters.productionGroup]);

  const TableChartColumns = [
    {
      label: "Item Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Rate", key: "Rate", align: "right", format: "true" },
    { label: "qty", key: "qty", align: "right", format: "true" },
    { label: "Amount", key: "Amount", align: "right", format: "true" },
    {
      label: "Cumulative Amount",
      key: "CumulativeAmount",
      align: "right",
      format: "true",
    },
  ];

  const TableChartRow = (ProdGrpMachineWiseCondata?.ItemWise || []).map(
    (row) => ({
      ItemName: row?.ItemName ?? "",
      Rate: row?.Rate ?? "",
      qty: row?.Qty ?? "",
      Amount: row?.Amount ?? "",
      CumulativeAmount: row?.CumulativeAmount ?? "",
    }),
  );

  const HIDE_COLUMNS = ["IssueMonth"];
  const removeAmtFromHeader = (key) => {
    return key.replace(/_Amt$/i, "");
  };

  const generateMasterWiseColumns1 = (data = [], hideColumns = []) => {
    if (!Array.isArray(data) || data.length === 0) return [];

    const ignoreKeys = ["Machine Name", "IssueMonthName"];

    return Object.keys(data[0])
      .filter((key) => !ignoreKeys.includes(key) && !hideColumns.includes(key))
      .map((key) => ({
        label: removeAmtFromHeader(key),
        key: key,
        width: 130,
        align: "right",
      }));
  };

  const columns = useMemo(() => {
    const detail = ProdGrpMachineWiseCondata?.MachineWise;

    if (!Array.isArray(detail) || detail.length === 0) return [];

    const dynamicCols = generateMasterWiseColumns1(detail, HIDE_COLUMNS);

    const allColumns = [
      {
        label: "Issue Month",
        key: "IssueMonthName",
        align: "left",
        colors: isdark === "light" ? "#000" : "#fff",
      },
      {
        label: "Machine Name",
        key: "Machine Name",
        align: "left",
        colors: isdark === "light" ? "#000" : "#fff",
      },
      { label: "Count", key: "count" },
      ...dynamicCols,
    ];

    // 👇 default isNumeric = true for rest
    return allColumns.map((col) => ({
      ...col,
      isNumeric: col.isNumeric ?? true,
    }));
  }, [ProdGrpMachineWiseCondata?.MachineWise]);

  const initialData = (ProdGrpMachineWiseCondata?.MachineWise || []).map(
    (row) => {
      const formattedRow = {};

      Object.keys(row || {}).forEach((key) => {
        formattedRow[key] =
          row[key] === null || row[key] === undefined ? "0.00" : row[key];
      });

      return formattedRow;
    },
  );

  const HIDE_COLUMNS1 = ["IssueMonth"];

  // const removeAmtFromHeader = (key = "") => {
  //     return key.replace(/_Amt$/i, "");
  // };

  const generateMasterWiseColumns = (data = [], hideColumns = []) => {
    if (!Array.isArray(data) || data.length === 0) return [];

    const ignoreKeys = ["MachineGroupMstName", "IssueMonthName"];

    return Object.keys(data[0])
      .filter((key) => !ignoreKeys.includes(key) && !hideColumns.includes(key))
      .map((key) => ({
        label: removeAmtFromHeader(key),
        key: key,
        width: 130,
        align: "right",
      }));
  };

  const columns1 = useMemo(() => {
    const detail = ProdGrpMachineWiseCondata?.MachineGrpWise;

    if (!Array.isArray(detail) || detail.length === 0) return [];

    const dynamicCols = generateMasterWiseColumns(detail, HIDE_COLUMNS1);

    const allColumns = [
      {
        label: "Issue Month",
        key: "IssueMonthName",
        width: 160,
        align: "left",
      },
      {
        label: "Machine Group Name",
        key: "MachineGroupMstName",
        width: 180,
        align: "left",
      },
      ...dynamicCols,
    ];

    // 👇 default isNumeric = true for rest
    return allColumns.map((col) => ({
      ...col,
      isNumeric: col.isNumeric ?? true,
    }));
  }, [ProdGrpMachineWiseCondata?.MachineGrpWise]);

  const initialData1 = (ProdGrpMachineWiseCondata?.MachineGrpWise || []).map(
    (row) => {
      const formattedRow = {};

      Object.keys(row || {}).forEach((key) => {
        formattedRow[key] =
          row[key] === null || row[key] === undefined ? "0.00" : row[key];
      });

      return formattedRow;
    },
  );

  if (!ColourfilterData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!ProdGrpMachineWiseCondata || ProdGrpMachineWiseCondata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        minHeight: "100vh",
        padding: "16px",
      }}
    >
      {/* 🔹 MOBILE BUTTON */}
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={() => setShowFilter(true)}
          style={{
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            border: "none",
          }}
        >
          <FiMenu />
        </Button>
      </div>

      {/* 🔹 OFFCANVAS */}
      <Offcanvas show={showFilter} onHide={() => setShowFilter(false)}
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        }}
      >
        <Offcanvas.Header closeButton
          closeVariant={isdark === "dark" ? "white" : undefined}
          style={{ color: isdark === "light" ? "#000" : "#FFF", }} >
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <ColourFilterBox
              title="Month"
              items={MonthListdata}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filters.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", MonthListdata)}
            />

            <ColourFilterBox
              title="Account"
              items={productionGroupList}
              search={search.productionGroup}
              setSearch={(val) => handleSearch("productionGroup", val)}
              selectedItems={filters.productionGroup}
              toggleItem={(item) => toggleItem("productionGroup", item)}
              selectAll={() =>
                selectAll("productionGroup", productionGroupList)
              }
            />
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Row>
        {/* 🔹 DESKTOP FILTER */}
        <Col xl={3} lg={4} className="d-none d-lg-block">
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <ColourFilterBox
              title="Month"
              items={MonthListdata}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filters.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", MonthListdata)}
            />

            <ColourFilterBox
              title="Account"
              items={productionGroupList}
              search={search.productionGroup}
              setSearch={(val) => handleSearch("productionGroup", val)}
              selectedItems={filters.productionGroup}
              toggleItem={(item) => toggleItem("productionGroup", item)}
              selectAll={() =>
                selectAll("productionGroup", productionGroupList)
              }
            />
          </div>
        </Col>

        {/* 🔹 RIGHT SIDE */}
        <Col xl={9} lg={8}>
          {/* 🔹 TOP TABLE (BUTTON KE UPAR) */}
          <div
            style={{
              borderRadius: "14px",
              overflow: "hidden",
              marginBottom: "20px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          >
            {/* 🔹 HEADING */}
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
                letterSpacing: "1px",
                fontSize: "18px"
              }}
            >
              ITEMWISE
            </div>

            <ColourTable data={TableChartRow} columns={TableChartColumns} />
          </div>


          {/* 🔹 BUTTONS */}
          <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
            {["Machine Wise", "Machine Group Wise"].map((btn) => (
              <button
                key={btn}
                onClick={() => setActiveTable(btn)}
                style={{
                  flex: 1,
                  height: "50px",
                  borderRadius: "12px",
                  cursor: "pointer",
                  fontWeight: "600",
                  border: `2px solid ${isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour8
                    }`,
                  background:
                    activeTable === btn
                      ? isdark === "light"
                        ? iscolour?.Colour6
                        : iscolourDark?.Colour8
                      : isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour4,
                  color:
                    activeTable === btn
                      ? isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1
                      : isdark === "light"
                        ? iscolour?.Colour8
                        : iscolourDark?.Colour8,
                }}
              >
                {btn}
              </button>
            ))}
          </div>

          {/* 🔹 TABLE SWITCH */}
          <div
            style={{
              borderRadius: "14px",
              overflow: "hidden",
              marginTop: "20px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          >
            {/* 🔹 HEADING */}
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
                letterSpacing: "1px",
                fontSize: "18px"
              }}
            >
              {activeTable?.toUpperCase()}
            </div>

            {/* 🔹 TABLE */}
            <ColourParentChild
              data={activeTable === "Machine Wise" ? initialData : initialData1}
              columns={activeTable === "Machine Wise" ? columns : columns1}
              dynamic={dynamic}
            />
          </div>
        </Col>
      </Row>
    </div >
  );
};
